import React from "react";

// Official WhatsApp glyph (single-color SVG, inheritable via fill="currentColor").
export default function WhatsAppIcon({ className = "w-4 h-4", ...rest }) {
  return (
    <svg
      viewBox="0 0 24 24"
      className={className}
      fill="currentColor"
      aria-hidden="true"
      {...rest}
    >
      <path d="M19.05 4.91A10 10 0 0 0 4.78 19.06L3 23l4.04-1.76A10 10 0 1 0 19.05 4.91Zm-7.04 15.28h-.01a8.27 8.27 0 0 1-4.22-1.15l-.3-.18-2.4 1.05.84-2.6-.2-.31a8.3 8.3 0 1 1 6.29 3.19Zm4.55-6.18c-.25-.13-1.48-.73-1.71-.81-.23-.08-.4-.13-.57.13-.17.25-.65.81-.79.97-.15.17-.29.19-.54.06-.25-.13-1.06-.39-2.02-1.25-.74-.66-1.24-1.48-1.39-1.73-.15-.25-.02-.39.11-.51.11-.11.25-.29.37-.43.13-.15.17-.25.25-.42.08-.17.04-.31-.02-.43-.06-.13-.57-1.38-.78-1.88-.21-.5-.42-.43-.57-.44h-.49c-.17 0-.43.06-.65.31-.23.25-.85.83-.85 2.03 0 1.2.87 2.35.99 2.51.13.17 1.72 2.62 4.17 3.67.58.25 1.03.4 1.38.51.58.18 1.1.16 1.51.1.46-.07 1.48-.6 1.69-1.18.21-.59.21-1.09.15-1.18-.06-.1-.23-.16-.48-.29Z" />
    </svg>
  );
}
